import React from 'react';
import { motion } from 'framer-motion';
import PreviousEventImage1 from "../assets/previous_event_1.png"
import PreviousEventImage2 from "../assets/previous_event_2.png"
import PreviousEventImage3 from "../assets/previous_event_3.png"

const PreviousEventSection = () => {
    const eventImages = [
        { id: 1, image: PreviousEventImage1, alt: 'Event 1' },
        { id: 2, image: PreviousEventImage2, alt: 'Event 2' },
        { id: 3, image: PreviousEventImage3, alt: 'Event 3' },
    ];

    return (
        <div className="py-6 px-4 bg-gray-100">
            <div className="max-w-7xl mx-auto">
                <div className='flex justify-between'>
                    <h2 className="text-2xl font-bold mb-4">Previous Event</h2>
                    <div className="flex space-x-2">
                        <button className="w-8 h-8 shadow-lg shadow-black bg-orange-500 text-white flex items-center justify-center">
                            &larr;
                        </button>
                        <button className="w-8 h-8 shadow-lg shadow-black bg-orange-500 text-white flex items-center justify-center">
                            &rarr;
                        </button>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <div className="flex space-x-4 overflow-x-auto scrollbar-hide">
                        {eventImages.map((item) => (
                            <motion.div
                                key={item.id}
                                className="flex-shrink-0 min-w-96 rounded-xl overflow-hidden group h-52 border-2 border-black bg-white"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, delay: item.id * 0.1 }}
                            >
                                <motion.img
                                    src={item.image}
                                    alt={item.alt}
                                    className="w-full h-full transition-all duration-200 object-cover"
                                    whileHover={{scale: 1.1}}
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviousEventSection;